import { Component } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-catalogue-analytics',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [
    {
      provide: TabComponent,
      useExisting: CatalogueAnalyticsComponent,
    },
  ],
  templateUrl: './catalogue-analytics.component.html',
  styleUrl: './catalogue-analytics.component.scss',
})
export class CatalogueAnalyticsComponent extends TabComponent {
  override name: string = this.dictionaryService.get('CatalogueAnalytics');

  public async main(): Promise<void> {}
}
